import { ComponentConfig } from "@measured/puck";
import { Space as SpaceComponent, SpaceProps } from "./Space";

export type { SpaceProps } from "./Space";

export const Space: ComponentConfig<SpaceProps> = {
    label: "Space",
    fields: {
        height: {
            type: "select",
            label: "Height",
            options: [
                { label: "Extra Small", value: 1 },
                { label: "Small", value: 2 },
                { label: "Medium", value: 4 },
                { label: "Large", value: 6 },
                { label: "Extra Large", value: 8 },
                { label: "Huge", value: 12 },
            ],
        },
        space: {
            type: "slot",
        },
    },
    defaultProps: {
        height: 4,
    },
    render: (props) => {
        const spaceProps = {
            ...props,
        };

        return <SpaceComponent {...spaceProps} />;
    },
};
